import React from 'react';
import Nav from '../containers/Nav';
import Title from '../containers/Title';
import cellDeath from '../img/cell-death.gif';

export default () => (
	<div className="container">
		<div className="col--one">
			<Title />
		</div>
		<div className="col--two">
			<Nav />
			<div className="fixed-rect fixed-rect--square">
				<div className="fixed-rect__inner">
                    <img src={cellDeath}></img>
				</div>
			</div>	
			<div>
                <p className="caption">Oxygen-deprived cancer cells, dying over a thirty minute period. Recorded on a super resolution microscope.</p>
				<p>Patricia is a scientist and artist. She aims to transform the lives of those living with chronic disease.</p>
			</div>
		</div>
	</div>	
)


// WEBPACK FOOTER //
// ./src/components/Home.js